import { HttpClient, httpResource } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Signal } from '@angular/core';
import {
  ICurrentSubscriptionPlan,
  ISubscriptionAddon,
  ICurrentSubscriptionSignatures,
} from '@dss-libs/portal/type/portal-types';
import { API_URL } from '@dss-libs/shared/utility/global-injection-tokens';
import { PAYMENT_URLS } from '../../urls/payment.urls';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  readonly #http = inject(HttpClient);
  readonly #apiUrl = inject(API_URL);

  currentSubscriptionPlanResource(shouldFetch?: Signal<boolean>) {
    return httpResource<ICurrentSubscriptionPlan>(() =>
      shouldFetch?.() === false ? undefined : `${this.#apiUrl}${PAYMENT_URLS.CURRENT_SUBSCRIPTION_PLAN}`
    );
  }

  changeSubscriptionPlan(planId: string) {
    return this.#http.post<void>(`${this.#apiUrl}${PAYMENT_URLS.CHANGE_SUBSCRIPTION_PLAN}`, { planId });
  }

  cancelSubscription() {
    return this.#http.post<ICurrentSubscriptionPlan>(`${this.#apiUrl}${PAYMENT_URLS.CANCEL_SUBSCRIPTION}`, {});
  }

  cancelScheduledSubscriptionPlan() {
    return this.#http.post<ICurrentSubscriptionPlan>(
      `${this.#apiUrl}${PAYMENT_URLS.CANCEL_SCHEDULED_SUBSCRIPTION_PLAN}`,
      {}
    );
  }

  removeScheduledSubscriptionCancellation() {
    return this.#http.post<ICurrentSubscriptionPlan>(
      `${this.#apiUrl}${PAYMENT_URLS.REMOVE_SCHEDULED_SUBSCRIPTION_CANCELLATION}`,
      {}
    );
  }

  subscriptionAddonsResource() {
    return httpResource<ISubscriptionAddon[]>(() => `${this.#apiUrl}${PAYMENT_URLS.ADDONS}`);
  }

  subscriptionSignaturesResource(shouldFetch?: Signal<boolean>) {
    return httpResource<ICurrentSubscriptionSignatures>(() =>
      shouldFetch?.() === false ? undefined : `${this.#apiUrl}${PAYMENT_URLS.GET_SUBSCRIPTION_SIGNATURES}`
    );
  }
}
